import axios from "./_axios";
import Answer from "@/types/Answer";
import Answers from "@/types/Answers";

const getSurveyInfo = async (instanceId: string) => {
  const { data } = await axios.get(`survey/${instanceId}/survey-info`);
  return data;
};
const getAllInstance = async (instanceId: string) => {
  const { data } = await axios.get(`survey/${instanceId}/all-base-questions`);
  return data;
};
const updateAllInstance = async (instanceId: string, answers: Answers[]) => {
  const { data } = await axios.post(
    `survey/${instanceId}/update-question-list`,
    answers,
    {}
  );
  return data;
};
const getInstance = async (instanceId: string) => {
  const data = await axios.get(`survey/${instanceId}`);
  return data;
};

const changeLang = async (instanceId: string, lang: string) => {
  const { data } = await axios.post(`survey/${instanceId}/lang`, lang, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return data;
};

const addAnswer = async (
  instanceId: string,
  questionId: string,
  answer: Answer
) => {
  const { data } = await axios.post(
    `survey/${instanceId}/${questionId}`,
    answer,
    {}
  );
  return data;
};

const addAnswers = async (instanceId: string, answers: Answers[]) => {
  const { data } = await axios.post(
    `survey/${instanceId}/answer-all`,
    answers,
    {}
  );
  return data;
};

export default {
  getSurveyInfo,
  getAllInstance,
  updateAllInstance,
  getInstance,
  changeLang,
  addAnswer,
  addAnswers,
};
